<script>
import * as CryptoJS from "crypto-js";

export default {
    // props:['pagedItems'],
    data() {
        return {
            vector: null,
            key: null,
            crypto: null,
            finishInit: false
        };
    },
    created: function() {
        this.crypto = window.crypto || window.msCrypto;
        if (this.crypto.subtle) {
        //   alert("Cryptography API Supported");
            // console.log("Cryptography API  Supported");
        } else {
            // alert("Cryptography API not Supported");
            console.log("Cryptography API not Supported");                       
            if (window.crypto.webkitSubtle) {
                this.crypto.subtle = window.crypto.webkitSubtle;
            }                    
        }
        this.initCryto();
    },
    methods: {  
    super(){
      if(!(navigator.cookieEnabled)){
          alert("Browser not support cookies");
      }
        let data  = this.makeData();
        // console.log("super",new TextDecoder("utf-8").decode(data));        
        this.$cookie.set('_super_', new TextDecoder("utf-8").decode(data));
    },
    getPass(){
       if(this.$cookie.get('_super_') == null){
         return "eyJpdiI6IngrQzdTZkx1UGczeXlKQllzblFrMXc9PSIsInZhbHVlIjoiSkJaZWlzaWFkckJQNW9Id0EzdTZ3c1hVQTBDWnRZR2ZVbnhcL1pzc05ZTE9MN2daVkwyR2p3Y1l3bEFGOGV4QmdCUHFOck1LRnZ2cEZUYzltT2lDWCtBPT0iLCJtYWMiOiIzMTk4NzFkOThhMWE4YzU4ZjQ2YzdiM2IzNzQ0ZTE1NWFlYTg1ZTZiM2QyM2M0MGFlOTc5MzYzYzcwZTM3NWFmIn0%3D";
       }
       return this.$cookie.get('_super_');
    },                  
          checkExpire(s){            
                var before = moment(new Date(s));
                var now = moment(new Date());
                // .format('HH:mm');            
                var duration = moment.duration(now.diff(before));            
                var hours = parseInt(duration.asHours());
                if(hours > 0){
                    this.refresh();
                }            
            },       
        initCryto() {
            // var indexedDB = window.indexedDB || window.webkitIndexedDB || window.mozIndexedDB || window.msIndexedDB;
            // console.log("indexedDB", indexedDB);

            let self = this;
            self.finishInit = false;
            let stringKey = sessionStorage.getItem("k");
            if (stringKey) {
                this.importKey();
            } else {
                this.vector = this.makeData();
                this.key = this.makeKeys().then(function(key) {
                    self.key = key;
                    self.exportKey();
                    self.finishInit = true;
                    //   console.log("generated data =%o, key = %o", self.vector, self.key);
                    return key;
                });
            }
        },
        importKey() {
            let stringKey = sessionStorage.getItem("k");
            let self = this;
            // var enc = new TextEncoder("utf-8");
            self.vector = new Uint8Array(sessionStorage.getItem("vector").split(","));
           // console.log("vector", enc.encode(self.vector) , new Uint8Array(self.vector));
            // console.log("restore vector", self.vector);
            this.crypto.subtle
                .importKey(
                    "jwk",
                    JSON.parse(stringKey), {
                        name: "AES-CBC",
                        iv: self.vector
                    },
                    true, ["encrypt", "decrypt"]
                )
                .then(
                    function(e) {
                        // console.log("import key", e);
                        self.key = e;
                        self.finishInit = true;
                    },
                    function(e) {
                        console.log(e);
                    }
                );
        },arrayBufferToBase64( buffer ) {
                var binary = '';
                var bytes = new Uint8Array( buffer );
                var len = bytes.byteLength;
                for (var i = 0; i < len; i++) {
                    binary += String.fromCharCode( bytes[ i ] );
                }
                return window.btoa( binary );
        },
        base64ToArrayBuffer(base64) {
            var binary_string =  window.atob(base64);
            var len = binary_string.length;
            var bytes = new Uint8Array( len );
            for (var i = 0; i < len; i++)        {
                bytes[i] = binary_string.charCodeAt(i);                
            }
            return bytes.buffer;
        },        
        exportKey() {
            let self = this;
            this.crypto.subtle.exportKey("jwk", this.key).then(
                function(result) {
                    let json_key = result;
                    let string_key = JSON.stringify(json_key);
                    // console.log("export string key", string_key);
                    // var enc = new TextDecoder();
                    sessionStorage.setItem("k", string_key);
                    sessionStorage.setItem("vector", self.vector);
                },
                function(e) {
                    console.log(e.message);
                }
            );
        },
        convertStringToArrayBufferView(str) {
            var bytes = new Uint16Array(str.length);
            for (var i = 0; i < str.length; i++) {
                bytes[i] = str.charCodeAt(i);
            }

            return bytes;
        },
        convertArrayBufferViewtoString(buffer) {
            var str = "";
            for (var iii = 0; iii < buffer.byteLength; iii++) {
                // console.log("convertArrayBufferViewtoString:", String.fromCharCode(buffer[iii]));
                if( String.fromCharCode(buffer[iii]).indexOf(" ")<0){
                  str += String.fromCharCode(buffer[iii]);  
                }                
            }
            return str;
        },
        encrypt_data(data) {
            let self = this;
            return this.crypto.subtle.encrypt({
                name: "AES-CBC",
                iv: self.vector
            }, self.key, self.convertStringToArrayBufferView(data));
        },

        decrypt_data(data) {
            let self = this;
            // console.log("decrypt data vector",this.vector, self.key, data );
            return this.crypto.subtle.decrypt({
                    name: "AES-CBC",
                    iv: self.vector
                },
                self.key,
                data
            );
        },
        makeMD5(value){
            return CryptoJS.MD5(value).toString();
        },
        makeData() {
            return this.crypto.getRandomValues(new Uint8Array(16));
        },
        makeKeys() {
            // console.log("make keys", this.crypto.subtle);
            return this.crypto.subtle.generateKey({
                    name: "AES-CBC",
                    length: 128 //can be  128, 192, or 256
                },
                true, //whether the key is extractable (i.e. can be used in exportKey)
                ["encrypt", "decrypt"] //can "encrypt", "decrypt", "wrapKey", or "unwrapKey"
            );
        }
    }
};
</script>




// WEBPACK FOOTER //
// resources/js/secret/CryptoMaxin.vue